import { render, staticRenderFns } from "./addPageSalePay.vue?vue&type=template&id=a048a0b2&scoped=true&"
import script from "./addPageSalePay.vue?vue&type=script&lang=js&"
export * from "./addPageSalePay.vue?vue&type=script&lang=js&"
import style0 from "./addPageSalePay.vue?vue&type=style&index=0&id=a048a0b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a048a0b2",
  null
  
)

export default component.exports